import type { PageViewMode } from '@/components/pages/home'
import { createRequiredContext } from './create-required-context'

/**
 * The open spread's identity and page geometry, in document points. Changes once per spread (or
 * when book settings load), so it's safe for many components to read.
 */
export interface DocumentLayout {
  spreadId: string
  spreadIndex: number
  totalPages: number
  pageViewMode: PageViewMode
  bleedWidth: number
  bleedHeight: number
  trimWidth: number
  trimHeight: number
  /** Fixed print-bleed band outside trim. */
  bleedMargin: number
  liveInset: number
  centerGap: number
  marginInside: number
  marginOutside: number
  marginTop: number
  marginBottom: number
  pageInnerWidth: number
  pageInnerHeight: number
  rightPageOriginX: number
  rightPageOriginY: number
  /** Spine x-coordinate (canvas doc-px) for Mirror Move; `null` on a single-last page. */
  mirrorSpineAxisX: number | null
}

const documentLayout = createRequiredContext<DocumentLayout>('DocumentLayout')

export const DocumentLayoutContext = documentLayout.Context
export const DocumentLayoutProvider = documentLayout.Provider
export const useDocumentLayout = documentLayout.useRequiredContext
